import * as React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Callout } from './callout';

/** Confirmação simples de ação destrutiva/irreversível, com o erro real da API inline. */
export function ConfirmDialog({
  aberto,
  titulo,
  descricao,
  confirmar,
  perigo = false,
  erro,
  enviando,
  aoConfirmar,
  aoFechar,
}: {
  aberto: boolean;
  titulo: string;
  descricao: React.ReactNode;
  confirmar: string;
  perigo?: boolean;
  erro?: string | null;
  enviando?: boolean;
  aoConfirmar: () => void;
  aoFechar: () => void;
}) {
  return (
    <Dialog open={aberto} onOpenChange={(valor) => !valor && !enviando && aoFechar()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription>{descricao}</DialogDescription>
        </DialogHeader>
        {erro ? <Callout tom="erro">{erro}</Callout> : null}
        <DialogFooter>
          <Button variant="outline" onClick={aoFechar} disabled={enviando}>
            Cancelar
          </Button>
          <Button variant={perigo ? 'danger' : 'primary'} loading={enviando} onClick={aoConfirmar}>
            {confirmar}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
